









































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator'
/* component */
import CommonHeader from '@/app/components/Common/Header.vue'
import PageTitle from '@/app/components/Common/PageTitle.vue'
import ErrorModal from '@/app/components/Common/ErrorModal.vue'
import DeleteModal from '@/app/components/Common/DeleteModal.vue'
import Loading from '@/app/components/Common/Loading.vue'
import Error409Modal from '@/app/components/Common/Error409Modal.vue'
import ErrorInfo from '@/app/components/Common/ErrorInfo.vue'
/* api */
import RiskDetailApi from '@/app/model/api/riskDetailApi'
import RiskCreateApi from '@/app/model/api/riskCreateApi'
import RiskEditApi from '@/app/model/api/riskEditApi'
import RiskDeleteApi from '@/app/model/api/riskDeleteApi'
/* module */
import CommonClass from '@/app/module/common'
import Validator from '@/app/module/validator'
import draggable from 'vuedraggable'

@Component({
  components: {
    CommonHeader,
    PageTitle,
    ErrorModal,
    DeleteModal,
    Loading,
    Error409Modal,
    draggable,
    ErrorInfo
  }
})
export default class RiskCreate extends Vue {
  private errorMessages: any = ''
  private alertText: string = ''
  private alertTitle: string = ''
  private riskData: any = {
    harvest_risk: {
      risk_name: '',
      remarks: ''
    },
    harvest_risk_items: []
  }
  private riskItems: any = []
  /* 表示非表示 */
  private showServerErrorModal: boolean = false
  private showDeleteModal: boolean = false
  private showLoading: boolean = true
  private isEdit: boolean = false
  private inDrag: boolean = false
  private showError409Modal: boolean = false
  private show400ErrorMessage: boolean = false

  created () {
    if (this.$route.path === '/master/risk/create') {
      this.isEdit = false
      this.showLoading = false
    } else {
      this.isEdit = true
      this.getRiskList()
    }
  }

  private getRiskList () {
    (async () => {
      const result = await RiskDetailApi.getRiskDetail(this.$route.params.risk_id)
      if (result.isOk()) {
        this.riskData = result.getPayload()
        if (this.riskData.harvest_risk_items.length !== 0) {
          for (let i in this.riskData.harvest_risk_items) {
            this.riskItems.push({
              risk_item_id: this.riskData.harvest_risk_items[i].risk_item_id,
              risk_item_name: this.riskData.harvest_risk_items[i].risk_item_name,
              sort_number: this.riskData.harvest_risk_items[i].sort_number,
              is_delete_flag: 0
            })
          }
        }
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'text')
        if (errorData.status_code === '409') {
          this.showError409Modal = true
        } else {
          this.alertText = errorData.alertText
          this.alertTitle = errorData.alertTitle
          this.show400ErrorMessage = true
          window.scrollTo({ top: 0, behavior: 'auto' })
        }
      }
      this.showLoading = false
    })()
  }

  private doSave () {
    /* バリデーションチェック */
    if (!this.isRiskCreate()) {
      window.scrollTo({ top: 0, behavior: 'auto' })
      this.alertText = ''
      this.alertTitle = ''
      this.show400ErrorMessage = true
      return
    } else {
      this.show400ErrorMessage = false
    }
    this.showLoading = true

    if (this.isEdit && this.riskData.harvest_risk_items.length !== 0) {
      // 編集の時、既存の項目が削除されている場合is_delete_flag=1
      for (let j in this.riskData.harvest_risk_items) {
        let some = this.riskItems.some((item: any) => item.risk_item_id === this.riskData.harvest_risk_items[j].risk_item_id)
        if (!some && this.riskData.harvest_risk_items[j].risk_item_id !== 0) {
          this.riskItems.push({
            risk_item_id: this.riskData.harvest_risk_items[j].risk_item_id,
            risk_item_name: this.riskData.harvest_risk_items[j].risk_item_name,
            sort_number: 0,
            is_delete_flag: 1
          })
        }
      }
    }

    // 並び順を追加
    this.riskData.harvest_risk_items = []
    for (let l in this.riskItems) {
      this.riskData.harvest_risk_items.push({
        risk_item_id: this.riskItems[l].risk_item_id,
        risk_item_name: this.riskItems[l].risk_item_name,
        sort_number: parseInt(l) + 1,
        is_delete_flag: this.riskItems[l].is_delete_flag
      })
    }

    if (this.isEdit) {
      this.riskEdit()
    } else {
      this.riskCreate()
    }
  }

  private async riskCreate () {
    const bodyData: any = {
      harvest_risk: {
        risk_name: this.riskData.harvest_risk.risk_name,
        remarks: this.riskData.harvest_risk.remarks
      },
      harvest_risk_items: this.riskData.harvest_risk_items
    }

    const result = await RiskCreateApi.doRiskCreate(bodyData)

    if (result.isOk()) {
      this.$store.commit('alertState/setAlertMessage', { type: 0, text: '収穫リスク登録が完了しました。' })
      this.$store.commit('alertState/setAlertFlag', true)
      this.$router.push('/master/risk').catch(e => {})
    } else {
      const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'POST', 'text')
      if (errorData.status_code === '409') {
        this.showError409Modal = true
      } else {
        this.alertText = errorData.alertText
        this.alertTitle = errorData.alertTitle
        this.show400ErrorMessage = true
        window.scrollTo({ top: 0, behavior: 'auto' })
      }
    }
    this.showLoading = false
  }

  private async riskEdit () {
    const bodyData: any = {
      harvest_risk: {
        risk_name: this.riskData.harvest_risk.risk_name,
        remarks: this.riskData.harvest_risk.remarks,
        time_stamp: this.riskData.harvest_risk.time_stamp
      },
      harvest_risk_items: this.riskData.harvest_risk_items
    }

    const result = await RiskEditApi.doRiskEdit(this.$route.params.risk_id, bodyData)

    if (result.isOk()) {
      this.$store.commit('alertState/setAlertMessage', { type: 0, text: '収穫リスク編集が完了しました。' })
      this.$store.commit('alertState/setAlertFlag', true)
      this.$router.push('/master/risk').catch(e => {})
    } else {
      const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'PUT', 'text')
      if (errorData.status_code === '409') {
        this.showError409Modal = true
      } else {
        this.alertText = errorData.alertText
        this.alertTitle = errorData.alertTitle
        this.show400ErrorMessage = true
        window.scrollTo({ top: 0, behavior: 'auto' })
      }
    }
    this.showLoading = false
  }

  private isRiskCreate () {
    const riskNameFlag = Validator.validateInputRiskName('riskNameErrorMessage', this.riskData.harvest_risk.risk_name)
    this.errorMessages = Object.assign({}, this.errorMessages, Validator.getErrorMessage())

    // 収穫リスク項目名で空のものがないかチェック
    let riskItemNameFlag = true
    if (this.riskItems.length !== 0) {
      for (let i in this.riskItems) {
        if (this.riskItems[i].risk_item_name === '') {
          riskItemNameFlag = false
          this.errorMessages.riskItemNameErrorMessage = 'リスク項目名は必ず入力してください。'
          this.$set(this.errorMessages, 'riskItemNameErrorMessage', 'リスク項目名は必ず入力してください。')
        } else {
          if (riskItemNameFlag) {
            this.$delete(this.errorMessages, 'riskItemNameErrorMessage')
          }
        }
      }
    }

    return riskNameFlag && riskItemNameFlag
  }

  private doRiskDelete () {
    (async () => {
      this.showLoading = true
      const result = await RiskDeleteApi.doRiskDelete(this.$route.params.risk_id)

      if (result.isOk()) {
        this.$store.commit('alertState/setAlertMessage', { type: 0, text: '収穫リスクを削除しました。' })
        this.$store.commit('alertState/setAlertFlag', true)
        this.$router.push('/master/risk').catch(e => {})
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'DELETE', 'text')
        if (errorData.status_code === '409') {
          this.showError409Modal = true
        } else {
          this.alertTitle = errorData.alertTitle
          this.alertText = errorData.alertText
          this.show400ErrorMessage = true
          window.scrollTo({ top: 0, behavior: 'auto' })
        }
      }
      this.showDeleteModal = false
      this.showLoading = false
    })()
  }

  private addList () {
    this.riskItems.push({
      risk_item_id: 0,
      risk_item_name: '',
      sort_number: 0,
      is_delete_flag: 0
    })
    setTimeout(this.scrollIntoViewRiskItem, 10)
  }

  private scrollIntoViewRiskItem () {
    let container: any = document.getElementById('riskItem' + (this.riskItems.length - 1))
    container.scrollIntoView({ behavior: 'instant' })
  }

  private deleteList (key: number) {
    this.riskItems.splice(key, 1)
  }

  private doCancel () {
    this.$router.push('/master/risk').catch(e => {})
  }
}
